export type OrgPickRow = { id: string; name: string };

export type BugReport = {
  id: string;
  user_id: string | null;
  organization_id: string | null;
  reporter_label?: string | null;
  organization_label?: string | null;
  /** Server-enriched display name for state_snapshot.active_lead_id.
   *  Null when the lead row no longer exists (deleted or RLS-filtered)
   *  or when the report has no active_lead_id at all. */
  active_lead_label?: string | null;
  /** True when the enriched lead is currently archived. Drives a small
   *  "(archived)" badge next to the name. Null when the lead wasn't
   *  found or no active_lead_id was captured. */
  active_lead_archived?: boolean | null;
  mode: string | null;
  description: string;
  status: string;
  priority: string;
  version: string | null;
  notes: string | null;
  resolution_summary: string | null;
  route_path: string | null;
  view_context: string | null;
  browser_info: string | null;
  state_snapshot: Record<string, unknown> | null;
  resolved_at: string | null;
  created_at: string;
};

export const STATUSES = ["open", "in_progress", "resolved", "wont_fix"] as const;
export const PRIORITIES = ["low", "normal", "high", "critical"] as const;
export const STATUS_FILTER_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "unresolved", label: "Unresolved" },
  ...STATUSES.map((status) => ({ value: status, label: status.replace("_", " ") })),
];

